import { useContext, useEffect, useState } from "react";
import {
  getMenu,
} from "../services/console/menu";
import { AppContext } from "../context";

type UseType = "INTERNAL" | "EXTERNAL";

export const useMenu = (type: UseType, infObject: {
  tenantid: string,
  roleid?: string,
  appid?: string,
  environmentid?: string,
}) => {
  const { toast, t } = useContext(AppContext);
  const [menu, setMenu] = useState<any>([]);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setMenu([]);
    setReload((prev) => prev + 1);
  };

  useEffect(() => {
      (async function () {
        await Promise.resolve(getMenu(type, infObject))
          .then((response) => {
            setMenu(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
  }, [toast, reload, type]);

  return {
    menu,
    reloadFn,
  };
};
